import React from 'react';
import { CTAButton } from './ui/CTAButton';
const painPoints = ['Pasás horas mirando videos de YouTube sobre carpintería y nunca das el primer paso', 'Cada mes te prometés que vas a empezar tu emprendimiento y cada mes pasa lo mismo', 'Tenés talento y manos hábiles pero no tenés dirección, sistema ni nadie que te muestre cómo', 'Ves cómo otros venden muebles en Marketplace que vos podrías fabricar mejor', 'Dejás el cuerpo en el trabajo y tu salario no cambia aunque des todo de vos', 'Sabés lo que es ensuciarte las manos, pero no lo que se siente vivir de lo que creás'];
export function PainPointsSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-221">
      <div className="max-w-4xl mx-auto" data-id="element-222">
        <h2 className="text-3xl md:text-4xl font-black text-center text-brand-dark mb-12" data-id="element-223">
          Si estás cansado de depender de un sueldo,{' '}
          <br className="hidden md:block" data-id="element-224" />
          <span className="text-brand-amber" data-id="element-225">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-6 mb-10 bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-226">
          {painPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-227">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-228">😤</span>
              <p className="text-lg md:text-xl font-medium text-gray-800" data-id="element-229">
                {point}
              </p>
            </div>)}
        </div>

        <div className="grid md:grid-cols-3 gap-6 mb-10" data-id="element-230">
          <div className="bg-amber-50 p-6 rounded-2xl border border-amber-200 text-center" data-id="element-231">
            <span className="text-4xl block mb-4" data-id="element-232">💪</span>
            <p className="text-lg font-bold text-gray-800" data-id="element-233">
              Tenés mano firme, constancia y ganas. Pero nadie te mostró cómo
              convertir eso en algo propio.
            </p>
          </div>
          <div className="bg-amber-50 p-6 rounded-2xl border border-amber-200 text-center" data-id="element-234">
            <span className="text-4xl block mb-4" data-id="element-235">🔩</span>
            <p className="text-lg font-bold text-gray-800" data-id="element-236">
              Sabés trabajar el hierro o la madera. Pero sin un sistema, el
              trabajo se te escapa entre los dedos.
            </p>
          </div>
          <div className="bg-amber-50 p-6 rounded-2xl border border-amber-200 text-center" data-id="element-237">
            <span className="text-4xl block mb-4" data-id="element-238">🔥</span>
            <p className="text-lg font-bold text-brand-rust" data-id="element-239">
              No necesitás más fuerza. Necesitás dirección, guía y un plan
              rentable.
            </p>
          </div>
        </div>

        <div className="bg-brand-light p-8 rounded-2xl border border-brand-amber/20 mb-12" data-id="element-240">
          <p className="text-lg md:text-xl text-gray-800 leading-relaxed text-center" data-id="element-241">
            <strong data-id="element-242">
              El problema no es tu capacidad. El problema es que nadie te dio el
              sistema.
            </strong>
            <br data-id="element-243" />
            <br data-id="element-244" />
            Mientras seguís buscando tutoriales sueltos en YouTube, hay gente
            sin más habilidad que vos publicando muebles en Marketplace y
            cerrando ventas por WhatsApp todos los días.
            <br data-id="element-245" />
            <br data-id="element-246" />
            <span className="font-black text-brand-dark" data-id="element-247">
              La diferencia no es el talento. Es tener el método correcto.
            </span>
          </p>
        </div>

        <div className="text-center" data-id="element-248">
          <div className="max-w-xl mx-auto" data-id="element-249">
            <CTAButton text="→ QUIERO DEJAR DE DEPENDER DE UN SUELDO" href="#compra" data-id="element-250" />
          </div>
        </div>
      </div>
    </section>;
}